import { render } from "./ServicesTypes.vue?vue&type=template&id=a455f5c4&scoped=true"
import script from "./ServicesTypes.vue?vue&type=script&lang=js"
export * from "./ServicesTypes.vue?vue&type=script&lang=js"

import "./ServicesTypes.vue?vue&type=style&index=0&id=a455f5c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a455f5c4"]])

export default __exports__